export default import.meta.ROLLDOWN_FILE_URL__1r2JWaj7oGUrnkkeqfDxQ